import { VersionCompare } from '../enums/version-compare.enum';
import { Translation, TranslationField } from '../models/translation.model';

export class UtilHelper {

	public static getEnumByCod(code: any, obj: any): any {
		const key: string = Object.keys(obj).find((k: string) => {
			return obj[k].code === code;
		});
		return obj[key];
	}

	public static getEnumByDescription(description: string, obj: any): any {
		const key: string = Object.keys(obj).find((k: string) => {
			return obj[key].description === description;
		});
		return obj[key];
	}

	public static getIdFromLocationPath(location: string): string {
		let id: string = null;
		if (location && location.length > 0) {
			const respSplited: Array<string> = location.split("/");
			if (respSplited.length > 0) {
				id = respSplited[respSplited.length - 1];
			}
		}
		return id;
	}

	public static getNumericValueIfPossible(value: any): number | string {
		let newValue: any = value;
		try {
			if (!isNaN(value)) {
				newValue = Number(value);
			}
		} catch (e) {
			newValue = value;
		}
		return newValue;
	}

	public static unmask(value: string): string {
		if (!value) return "";
		return value.replace(/[^a-z0-9]/gi, "");
	}

	public static formatAmountAndRemoveNegativeSymbol(amount: number): string {
		if (amount == null) return "";
		let amountFormated: string = String(amount.toFixed(2));
		amountFormated = amountFormated.replace("-", "").replace(".", ",");
		return amountFormated;
	}

	public static getTranslationByField(translations: Translation[], field: TranslationField): Translation {
		if (translations && translations.length > 0) {
			return translations.find((t) => t.field == field);
		}
		return null;
	}

	public static capitalizeFirst(value: string) {
		if (!value) return "";
		return value.charAt(0).toUpperCase() + value.slice(1);
	}

	public static mask(v: string, mask: string): string {
		if (!v) return v;
		let s: string = '';

		const matches: RegExpMatchArray = String(v).match(/[a-zA-Z0-9]+/g);
		if (matches !== null) {
			if (mask == null) return;

			let value: Array<string> = matches.join('').split('');
			const chars: Array<string> = mask.split('');
			for (const c of chars) {
				if (value.length === 0) {
					break;
				}
				switch (c) {
					case '#': //qualquer
						s += value[0];
						value = value.slice(1);
						break;

					case '9':
						if (value[0].match(/\d/) !== null) {
							s += value[0];
							value = value.slice(1);
						}
						break;

					case 'A':
						if (value[0].match(/[a-zA-Z]/) !== null) {
							s += value[0];
							value = value.slice(1);
						}
						break;

					default:
						s += c;
				}
			}
			return s;
		}
	}

	/**
	 * Compara versões
	 * @param localVersion
	 * @param remoteVersion
	 */
	public static compareVersions(localVersion: string, remoteVersion: string): VersionCompare {
		if (localVersion === remoteVersion) {
			return VersionCompare.IDENTICAL_VERSIONS;
		}

		const local_components: Array<string> = localVersion.split(".");
		const remote_components: Array<string> = remoteVersion.split(".");

		const len: number = Math.min(local_components.length, remote_components.length);

		// loop while the components are equal
		for (let i: number = 0; i < len; i++) {

			// Local maior que remoto
			if (parseInt(local_components[i]) > parseInt(remote_components[i])) {
				return VersionCompare.LOCAL_VERSION_HIGHER;
			}

			// Remoto maior que local
			if (parseInt(local_components[i]) < parseInt(remote_components[i])) {
				return VersionCompare.REMOTE_VERSION_HIGHER;
			}
		}

		// If one's a prefix of the other, the longer one is greater.
		if (local_components.length > remote_components.length) {
			return VersionCompare.LOCAL_VERSION_HIGHER;
		}

		if (local_components.length < remote_components.length) {
			return VersionCompare.REMOTE_VERSION_HIGHER;
		}

		// Otherwise they are the same.
		return VersionCompare.IDENTICAL_VERSIONS;
	}

	/**
	 * Scroll horizontal.
	 * Adaptação do código https://gist.github.com/felipenmoura/650e7e1292c1e7638bcf6c9f9aeb9dd5
	 * @param to
	 * @param element
	 * @param duration
	 */
	public static scrollHorizontalTo(to: number, element: HTMLElement, duration: number = 500): Promise<void> {
		//t = current time
		//b = start value
		//c = change in value
		//d = duration
		const easeInOutQuad: any = (t, b, c, d) => {
			t /= d / 2;
			if (t < 1) return c / 2 * t * t + b;
			t--;
			return -c / 2 * (t * (t - 2) - 1) + b;
		};

		return new Promise((resolve) => {
			const start: number = element.scrollLeft,
				change: number = to - start,
				increment: number = 20;

			let currentTime: number = 0;

			const animateScroll: VoidFunction = () => {
				currentTime += increment;
				const val: any = easeInOutQuad(currentTime, start, change, duration);
				element.scrollLeft = val;
				if (currentTime < duration) {
					setTimeout(animateScroll, increment);
				} else {
					resolve();
				}
			};
			animateScroll();
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/utils.helper.ts